import React from 'react';

const NotFound = () => {
    return (
        <div className="text-center"> 
          
            <img className="img-fluid" src="https://www.obesitydoctor.in/img/pageimg/404-medical.jpg" alt="" />
        </div>
    );
};

export default NotFound;